import { createFileRoute } from '@tanstack/react-router';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/alerts')({
  staticData: { owner: CodeOwner.IDNP },
});
